<header class="page-title"> &nbsp;{{additionalTitle}} &nbsp; {{'Common.Headers.'+title | translate}}

  <a *ngIf="showHistoryButton" (click)="backToPrevious()" href="javascript:void(0)" class="button-back"></a>
  <a *ngIf="showAddClaim"  (click)="redirectToAddCalim($event)" markDisabled="true"  class="btn addNewClaim">+
    {{'Common.Add-New'|translate}}</a>
    <a *ngIf="showAddAvailabilityButton" [routerLink]="['/availability/add']" routerLinkActive="router-link-active"    class="btn">+
      {{'Common.Add-New'|translate}}</a>

      <a *ngIf="showAddCounselorButton" [routerLink]="['add']" routerLinkActive="router-link-active"    class="btn">+
        {{'Common.Add-New'|translate}}</a>
        <a *ngIf="showAddSiteButton" [routerLink]="['add']" routerLinkActive="router-link-active"    class="btn">+
          {{'Common.Add-New'|translate}}</a>


          <a *ngIf="showAddLicense" [routerLink]="['add']" routerLinkActive="router-link-active"    class="btn">+
            {{'Common.Add-New'|translate}}</a>
            <a *ngIf="showAddLiability" [routerLink]="['add']" routerLinkActive="router-link-active"    class="btn">+
              {{'Common.Add-New'|translate}}</a>
</header>